"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentSubscription = exports.getSubscriptionState = exports.PlanStatus = exports.getValidSubscriptions = exports.hasValidPlanForTransactionCount = exports.hasValidPlanWith = exports.SUBSCRIPTION_END_GRACE_PERIOD_HOURS = void 0;
const date_fns_1 = require("date-fns");
exports.SUBSCRIPTION_END_GRACE_PERIOD_HOURS = 48;
function hasValidPlanWith({ cond, subscriptions, }) {
    return getValidSubscriptions({
        subscriptions: subscriptions,
    }).some((s) => cond({
        plan: s.plan,
    }));
}
exports.hasValidPlanWith = hasValidPlanWith;
function hasValidPlanForTransactionCount({ transactionCount, subscriptions, }) {
    return getValidSubscriptions({
        subscriptions: subscriptions,
    }).some((subscription) => {
        return transactionCount <= subscription.plan.features.transactionLimit;
    });
}
exports.hasValidPlanForTransactionCount = hasValidPlanForTransactionCount;
function getValidSubscriptions({ subscriptions, }) {
    const now = new Date();
    return subscriptions.filter((subscription) => subscription.status === "valid" &&
        now >= subscription.begins &&
        now <= (0, date_fns_1.addHours)(subscription.ends, exports.SUBSCRIPTION_END_GRACE_PERIOD_HOURS));
}
exports.getValidSubscriptions = getValidSubscriptions;
var PlanStatus;
(function (PlanStatus) {
    PlanStatus["None"] = "None";
    PlanStatus["Active"] = "Active";
    PlanStatus["DowngradeScheduled"] = "Downgrade Scheduled";
    PlanStatus["Cancelled"] = "Cancelled";
    PlanStatus["RequiresAction"] = "Requires Action";
    PlanStatus["Expired"] = "Expired";
})(PlanStatus = exports.PlanStatus || (exports.PlanStatus = {}));
function getSubscriptionState(subscription) {
    const now = new Date();
    const lapsed = (0, date_fns_1.addHours)(subscription.ends, exports.SUBSCRIPTION_END_GRACE_PERIOD_HOURS) < now;
    const downgrading = !!subscription.downgradeToPlan;
    const cancelled = !!subscription.isCancelled;
    const expired = subscription.stripeLastStatus === "canceled" ||
        !subscription.current ||
        // check if it's a lapsed manual plan (no stripe id)
        (!subscription.stripeLastStatus && lapsed);
    const valid = subscription.status === "valid" && !lapsed;
    const lapsesOn = (0, date_fns_1.addHours)(subscription.ends, exports.SUBSCRIPTION_END_GRACE_PERIOD_HOURS);
    const renewsOn = subscription.ends;
    const planStatus = parsePlanStatus({
        downgrading,
        cancelled,
        expired,
        valid,
    });
    return {
        lapsed,
        downgrading,
        cancelled,
        expired,
        valid,
        lapsesOn,
        renewsOn,
        planStatus,
    };
}
exports.getSubscriptionState = getSubscriptionState;
function parsePlanStatus({ downgrading, cancelled, expired, valid, }) {
    if (expired) {
        return PlanStatus.Expired;
    }
    if (!valid) {
        return PlanStatus.RequiresAction;
    }
    if (cancelled) {
        return PlanStatus.Cancelled;
    }
    if (downgrading) {
        return PlanStatus.DowngradeScheduled;
    }
    return PlanStatus.Active;
}
/**
 * Get current subscription. Stripe based first or manual otherwise.
 * @param subscriptions
 */
const getCurrentSubscription = (subscriptions) => {
    var _a, _b, _c;
    return (
    // any plan which isn't expired and uses a stripe subscription is preferred.
    (_c = (_b = (_a = subscriptions.find((s) => getSubscriptionState(s).planStatus !== PlanStatus.Expired &&
        s.stripeSubscriptionId)) !== null && _a !== void 0 ? _a : 
    // otherwise, it could be a non-expired manual plan
    subscriptions.find((s) => getSubscriptionState(s).planStatus !== PlanStatus.Expired)) !== null && _b !== void 0 ? _b : 
    // otherwise, it could be an expired stripe plan
    subscriptions.find((s) => s.stripeSubscriptionId)) !== null && _c !== void 0 ? _c : 
    // otherwise, it could be anything left, such as an expired manual plan
    subscriptions[0]);
};
exports.getCurrentSubscription = getCurrentSubscription;
